import { render, staticRenderFns } from "./Webhooks_MD.vue?vue&type=template&id=1321519f&scoped=true"
import script from "./Webhooks_MD.vue?vue&type=script&lang=js"
export * from "./Webhooks_MD.vue?vue&type=script&lang=js"
import style0 from "./Webhooks_MD.vue?vue&type=style&index=0&id=1321519f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1321519f",
  null
  
)

export default component.exports